import React from 'react';
import { Link } from 'react-router-dom';
import './businessDetail.css';

const BusinessDetail = () => {
    const services = [
        {
            number: '01',
            icon: 'mdi-tools',
            title: '전문 설치',
            description: '장비 운송부터 설치, 세팅, 철거까지 전문적인 설치 서비스를 제공합니다.'
        },
        {
            number: '02',
            icon: 'mdi-cog-outline',
            title: '현장 운영',
            description: '행사 진행 중 안정적인 운영을 위해 전문 인력이 현장을 지원합니다.'
        },
        {
            number: '03',
            icon: 'mdi-message-outline',
            title: '맞춤 컨설팅',
            description: '행사 목적과 공간, 규모에 맞는 최적의 장비 구성을 제안합니다.'
        }
    ];

    const process = [
        {
            number: '01',
            icon: 'mdi-phone-outline',
            title: '문의 및 상담',
            description: '행사 내용과 장소, 규모를 상담합니다.'
        },
        {
            number: '02',
            icon: 'mdi-calendar-check-outline',
            title: '일정 확인',
            description: '행사 일정과 장비 렌탈 가능 여부를 확인합니다.'
        },
        {
            number: '03',
            icon: 'mdi-cog-outline',
            title: '장비 구성',
            description: '목적에 맞는 장비를 선정하고 제안합니다.'
        },
        {
            number: '04',
            icon: 'mdi-tools',
            title: '설치 및 운영',
            description: '전문 인력이 설치하고 행사 현장을 지원합니다.'
        },
        {
            number: '05',
            icon: 'mdi-package-variant',
            title: '철거 및 마무리',
            description: '행사 종료 후 장비를 안전하게 철거합니다.'
        }
    ];

    return (
        <div className="business-detail">

            {/* SUB VISUAL */}
            <section className="business-sub-visual">
                <div className="business-sub-overlay"></div>

                <div className="business-sub-inner">
                    <p>BUSINESS</p>

                    <h1>사업분야</h1>

                    {/* <span>
                        공간과 목적에 맞는
                        <br />
                        최적의 영상 환경을 제공합니다.
                    </span> */}

                    <div className="business-breadcrumb">
                        <Link to="/">
                            HOME
                        </Link>

                        <span>›</span>

                        <strong>
                            사업분야
                        </strong>
                    </div>
                </div>
            </section>

            {/* INTRO */}
            <section className="business-intro">
                <div className="business-container">

                    <div className="business-section-title">
                        <p>OUR BUSINESS</p>

                        <h2>
                            영상이 필요한 모든 순간,<br />
                            현장에 맞는 솔루션을 제공합니다.
                        </h2>

                        <span>
                            MTMEDIA는 LED 전광판과 빔프로젝터 렌탈을 중심으로
                            <br />
                            장비 선정부터 설치, 운영, 철거까지 함께합니다.
                        </span>
                    </div>

                </div>
            </section>

            {/* LED */}
            <section className="business-field">
                <div className="business-container">
                    <div className="business-field-grid">

                        <div className="business-field-content">
                            <span className="business-number">01</span>

                            <p className="business-field-eng">
                                LED DISPLAY
                            </p>

                            <h2>LED 전광판 렌탈</h2>

                            <p className="business-field-description">
                                실내·실외 행사 환경과 관람 거리를 고려하여
                                현장에 적합한 LED 전광판을 구성합니다.
                                행사 규모와 사용 목적에 따라 적절한 픽셀 피치와
                                화면 크기를 제안합니다.
                            </p>

                            <ul>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    기업행사
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    전시
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    공연 · 축제
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    광고 촬영
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    세미나 · 컨퍼런스
                                </li>
                            </ul>

                            <Link
                                to="/products/led"
                                className="business-detail-button"
                            >
                                LED 제품 보기
                                <i className="mdi mdi-arrow-right"></i>
                            </Link>
                        </div>

                        <div className="business-field-image">
                            <img
                                src="/images/product/led/led1.png"
                                alt="LED 전광판 렌탈"
                            />
                        </div>

                    </div>
                </div>
            </section>

            {/* PROJECTOR */}
            <section className="business-field business-field-gray">
                <div className="business-container">
                    <div className="business-field-grid reverse">

                        <div className="business-field-content">
                            <span className="business-number">02</span>

                            <p className="business-field-eng">
                                PROJECTOR
                            </p>

                            <h2>빔프로젝터 렌탈</h2>

                            <p className="business-field-description">
                                행사장의 크기와 조도, 공간 특성을 고려하여
                                적합한 프로젝터와 스크린을 구성합니다.
                                행사 환경에 맞는 밝기와 화면 크기를 고려해
                                안정적인 영상 환경을 제공합니다.
                            </p>

                            <ul>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    세미나 · 컨퍼런스
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    기업행사
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    전시
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    발표회
                                </li>
                                <li>
                                    <i className="mdi mdi-check"></i>
                                    교육 · 기타 행사
                                </li>
                            </ul>

                            <Link
                                to="/products/projector"
                                className="business-detail-button"
                            >
                                프로젝터 제품 보기
                                <i className="mdi mdi-arrow-right"></i>
                            </Link>
                        </div>

                        <div className="business-field-image">
                            <img
                                src="/images/product/projector/projector-07.png"
                                alt="빔프로젝터 렌탈"
                            />
                        </div>

                    </div>
                </div>
            </section>

            {/* TOTAL SERVICE */}
            <section className="business-total-service">
                <div className="business-total-overlay"></div>

                <div className="business-container business-total-inner">

                    <div className="business-section-title light">
                        <p>TOTAL SERVICE</p>

                        <h2>
                            장비만 대여하는 것이 아니라<br />
                            현장까지 함께하는 MTMEDIA
                        </h2>
                    </div>

                    <div className="business-service-list">
                        {services.map((service) => (
                            <div
                                className="business-service-card"
                                key={service.number}
                            >
                                <span>{service.number}</span>

                                <div className="business-service-icon">
                                    <i className={`mdi ${service.icon}`}></i>
                                </div>

                                <h3>{service.title}</h3>

                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/* PROCESS */}
            <section className="business-process">
                <div className="business-container">

                    <div className="business-section-title">
                        <p>RENTAL PROCESS</p>
                        <h2>렌탈 진행 절차</h2>

                        <span>
                            문의부터 설치와 행사 마무리까지,
                            체계적인 과정으로 진행합니다.
                        </span>
                    </div>

                    <div className="business-process-list">
                        {process.map((item, index) => (
                            <React.Fragment key={item.number}>

                                <div className="business-process-item">
                                    <div className="business-process-icon">
                                        <i className={`mdi ${item.icon}`}></i>
                                    </div>

                                    <span>{item.number}</span>
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>

                                {index < process.length - 1 && (
                                    <div className="business-process-arrow">
                                        <i className="mdi mdi-arrow-right"></i>
                                    </div>
                                )}

                            </React.Fragment>
                        ))}
                    </div>

                </div>
            </section>

            {/* CTA */}
            <section className="business-cta">
                <div className="business-cta-overlay"></div>

                <div className="business-cta-inner">
                    <p>MTMEDIA CONSULTING</p>

                    <h2>프로젝트가 준비되어 있으신가요?</h2>

                    <span>
                        행사 장소와 규모, 사용 목적을 알려주시면
                        <br />
                        현장에 적합한 영상 장비를 안내해드립니다.
                    </span>

                    <Link
                        to="/inquiry"
                        className="business-cta-button"
                    >
                        견적문의 하기
                        <i className="mdi mdi-arrow-right"></i>
                    </Link>
                </div>
            </section>

        </div>
    );
};

export default BusinessDetail;